import React from 'react';
import { 
  FaBriefcase, 
  FaCode, 
  FaPaintBrush, 
  FaChartBar, 
  FaRobot, 
  FaChartLine 
} from 'react-icons/fa';
import './Services.css';

const Services = () => {
  const services = [
    {
      icon: <FaBriefcase className="service-icon-svg" />,
      title: 'Business Strategy',
      description: 'Strategic planning and in-depth analysis to identify growth opportunities and optimize operations'
    },
    {
      icon: <FaCode className="service-icon-svg" />,
      title: 'Technology Solutions',
      description: 'Custom tech solutions designed to streamline processes and enhance productivity'
    },
    {
      icon: <FaPaintBrush className="service-icon-svg" />,
      title: 'Creative Solutions',
      description: 'Innovative design and creative strategies to elevate your brand and customer experience'
    },
    {
      icon: <FaChartBar className="service-icon-svg" />,
      title: 'Process Optimization',
      description: 'Analyze and improve workflows to eliminate inefficiencies and reduce costs'
    },
    {
      icon: <FaRobot className="service-icon-svg" />,
      title: 'Ai Integration',
      description: 'Facilitate Artificial intelligence(Ai) adaptation and Ai resource implementation'
    },
    {
      icon: <FaChartLine className="service-icon-svg" />,
      title: 'Growth Consulting',
      description: 'Data-driven insights to accelerate growth and maximize market potential'
    }
  ];

  return (
    <section id="services" className="services">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Our Services</h2>
        </div>
        <div className="services-grid">
          {services.map((service, index) => (
            <div key={index} className="service-card">
              <div className="service-icon">{service.icon}</div>
              <h3 className="service-title">{service.title}</h3>
              <p className="service-description">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;

